import { asMoment } from 'dates';
import * as moment from 'moment';

const dtfmt = window.hcstatic.portal_language === 'en' ? 'MMM Do h:mm a' : 'MMM Do H:mm';

export const displayDate = (str: string): string => {
	if (!str) {
		return '';
	}
	const posted = asMoment(str);
	const now = moment();
	let rv;
	if (posted > now.startOf('day')) {
		rv = posted.fromNow();
	} else if (posted > now.subtract(6, 'days')) {
		rv = posted.calendar();
	} else if (posted > now.startOf('year')) {
		rv = posted.format(dtfmt);
	} else {
		rv = posted.format('lll');
	}
	return rv;
};
